import React, { Component, useState ,useEffect} from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Config from '../Helpers/Config';


function Filter(props) {

  
    const [fromDate, setFromDate] = useState(new Date("01-Jan-1970"));
    const [toDate, setToDate] = useState(new Date(props?.payload?.asOfDate ?? new Date()));

    const sendData = (dates)=>{
        props.getData(dates)
    }

    const onChangeFromDate =(date)=>{
        setFromDate(date)
        sendData({fromDate:date,toDate:toDate})
    }

    const onChangeToDate =(date)=>{
        setToDate(date)
        sendData({fromDate:fromDate,toDate:date})
    }

    const refreshTheData = ()=>{
        props.reloadData()
    }
    const CustomInput1 = React.forwardRef(({ value, onClick }, ref) => {
        return (
            <div className="input-group mb-3 customDatePicker">
            <input type="text" className="form-control datefield no-border-radius" aria-label="date" aria-describedby="date" defaultValue={value} onClick={onClick}/>
            <div className="input-group-append">
              <span className="input-group-text" id="basic-addon2"><i className="fa fa-calendar"></i></span>
            </div>
          </div>
        );
    });

    const CustomInput2 = React.forwardRef(({ value, onClick }, ref) => {
        return (
            <div className="input-group mb-3 customDatePicker">
            <input type="text" className="form-control datefield no-border-radius" aria-label="date" aria-describedby="date" defaultValue={value} onClick={onClick}/>
            <div className="input-group-append">
              <span className="input-group-text" id="basic-addon2"><i className="fa fa-calendar"></i></span>
            </div>
          </div>
        );
    });


    return (
        <React.Fragment>
            <div className="trxFilter">
                        <div className="mb-3 col-sm-12 b-b-1 pb-2">
                                <label className="col-sm-12 col-form-label">
                                    <b>Portfolio (s):</b> {props && props.filterData && props.filterData.portfolios ? props.filterData.portfolios.map(x=>x.name).join(",") : ""} 
                                </label>
                        </div>
                        <div className="row align-middle">
                            <div className="col-sm-3">
                                <div className="col-sm-12">
                                    <b>From:</b>
                                </div>
                                <div className="col-sm-12 mt-2">
                                    <DatePicker
                                        closeOnScroll={true}
                                        selected={fromDate}
                                        dateFormat={Config.dateFormatInput}
                                        onChange={(date) => onChangeFromDate(date)}
                                        placeholderText="From Inception"
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        customInput={<CustomInput1/>}
                                        />
                                    
                                    </div>
                            </div>
                            <div className="col-sm-3">
                                <div className="col-sm-12">
                                    <b>To:</b>
                                </div>
                                <div className="col-sm-12 mt-2">
                                    <DatePicker
                                        closeOnScroll={true}
                                        selected={toDate}
                                        dateFormat={Config.dateFormatInput}
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        onChange={(date) => onChangeToDate(date)}
                                        customInput={<CustomInput1/>}
                                        />
                                    
                                    </div>
                            </div>
                            <div className="col-sm-3">
                                <button className="btn btn-refresh" onClick={refreshTheData}>
                                    <i className="fa fa-refresh"></i> Refresh
                                </button>
                            </div>
                        </div>

            </div>
        </React.Fragment>
    )
}

export default Filter
